export const getSideDrawerContainerStyle = () => ({
  paddingTop: "80px",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-between",
});

export const getSideDrawerListStyle = () => ({
  paddingY: "16px",
  paddingX: "32px",
});

export const getSideDrawerItemListStyle = () => ({
  fontSize: "16px",
  fontFamily: "kanit",
  fontWeight: "300",
  color: "#383838",
  paddingLeft: "16px",
});
